import React from 'react';
import icRefresh from '../static/refresh.svg';
import { wrap } from './style';

interface Props {
  isFetching?: boolean;
  size?: number;
}

function Refresh({ isFetching, size = 16 }: Props) {
  return <img src={icRefresh} css={wrap(isFetching)} width={size} />;
}

export default Refresh;
